<template>
  <span class="text-center title">
    {{text}}
  </span>
</template>

<script>
export default {
  name: 'TitleCard',
  props:{
    text:{
      type: String,
      required: false,
      default: '--',
    },
  }
}
</script>
